import Modal from "@components/ModalTemplate";
import NiceModal, { useModal } from "@ebay/nice-modal-react";
import Button from "@components/Button";
import "./style.scss";
import howitworks from "./img/howitworks.jpg";
import howitworksM from "./img/howitworksM.jpg";
import { useRef, useState } from "react";
import { useWindowSize } from "@app/Helpers";

export default NiceModal.create(() => {
  const modal = useModal();
  const [trackName, setTrackName] = useState("");
  const [isSending, setIsSending] = useState(false);

  const isSendingRef = useRef(false);

  const { width } = useWindowSize();
  const XGA = width >= 1020;

  const {
    content,
    onConfirm,
    onCancel,
    sendAnswers,
    setCurrentQuestion,
    selected,
    tempo,
  } = modal.args;

  const handleClose = () => {
    modal.hide();
  };

  const sendTrack = () => {
    const trimmedTrackName = trackName.trim();

    if (isSendingRef.current || trimmedTrackName === "") return;

    isSendingRef.current = true;
    setIsSending(true);

    try {
      const result = sendAnswers(
        () => {
          setCurrentQuestion((prev) => prev + 1);
          modal.hide();
        },
        {
          selected,
          tempo,
          name: trimmedTrackName,
        },
      );

      if (result?.catch) {
        result.catch(() => {
          isSendingRef.current = false;
          setIsSending(false);
        });
      }
    } catch (error) {
      isSendingRef.current = false;
      setIsSending(false);
      throw error;
    }
  };

  return (
    <Modal
      isOpen={modal.visible}
      onClose={() => {
        handleClose();
      }}
      onAfterClose={() => modal.remove()}
      innerClass={`dj-console-modal ${content}`}
    >
      {content === "ios-info" && (
        <div className="ios-info">
          <p>
            Damit du den Ton hörst, stelle sicher, dass dein Telefon nicht auf
            lautlos gestellt ist.
          </p>

          <Button
            action={() => {
              handleClose();
            }}
          >
            OK
          </Button>
        </div>
      )}

      {content === "how-it-works" && (
        <div className="howitworks">
          <img src={XGA ? howitworks : howitworksM} alt="How it works" />

          <Button
            action={() => {
              handleClose();
            }}
          >
            OK
          </Button>
        </div>
      )}

      {content === "send" && (
        <div className="send">
          <h4 className="title">Mix benennen</h4>
          <p className="copy">
            Gib deinem Track einen Namen und reiche ihn ein, um am Gewinnspiel
            teilzunehmen. Mit deiner Teilnahme sicherst du dir die Chance auf:
          </p>
          <p className="copy prize">
            1 Cabana Package fuer Tomorrowland Weekend 1 vom 16.- 20. Juli inkl.
            Tickets, Unterkunft und ausgewaehlten Services fuer 2 Personen
          </p>
          <p className="copy date">
            Die Gewinner:innen werden bis zum 14. Juni kontaktiert.
          </p>

          <div className="track-name-wrapper">
            <label className="track-name-label" htmlFor="track-name">
              Trackname
            </label>
            <textarea
              id="track-name"
              className="track-name"
              placeholder="Trackname eingeben"
              maxLength={50}
              value={trackName}
              disabled={isSending}
              onChange={(e) => setTrackName(e.target.value)}
            />

            <p className="track-name-length">{trackName.length}/50</p>
          </div>

          <Button
            disabled={trackName.trim() === "" || isSending}
            action={sendTrack}
          >
            {isSending ? "WIRD GESENDET..." : "Absenden & teilnehmen"}
          </Button>
        </div>
      )}

      {content === "quitting" && (
        <div className="quitting">
          <h4 className="title">Verlaesst du die Buehne?</h4>

          <p className="copy">
            <strong>
              Dein Track<span>wird nicht gespeichert.</span>
              <br /> Sende ihn ab, wenn du am Wettbewerb teilnehmen moechtest.
            </strong>
          </p>

          <p className="copy">
            Denke daran, dass du nur einen Track einreichen kannst und er nach
            dem Absenden weder bearbeitet noch erneut eingereicht werden kann.
          </p>

          <div className="btns">
            <Button
              btnClass="outline"
              action={() => {
                onConfirm();
              }}
            >
              VERLASSEN
            </Button>

            <Button
              action={() => {
                onCancel();
                handleClose();
              }}
            >
              ZURUECK AUF DIE BUEHNE
            </Button>
          </div>
        </div>
      )}
    </Modal>
  );
});
